import React from 'react';

import CommonUtil from '../../../../utils/commonUtil';
import EventIcon from '../../../../components/EventIcon/EventIcon';
import { calendarSvgIcon } from '../../../createEvent/page/SelectMesaType/components/svgIcons';

export default class WapEventSearchResultCard extends React.Component {
  constructor(props) {
    super(props);
    this.loadCounter = 0;
  }
  styles = {
    card: {
      backgroundColor: 'white',
      borderRadius: '0.8rem',
      padding: '0.8rem 1.2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems : 'center',
      columnGap: '2.4rem',
    },
    card__graphic: {
      display: 'flex',
      alignItems: 'center',
      borderRadius:'50%',
      border:`1px solid ${this.props.themeData?.color_500}`
    },
    card__graphic__image: {
      width: '6.8rem',
      height: '6.8rem',
    },
    card__info: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      rowGap: '0.4rem',
    },
    card__info__name: {
      fontSize: '1.6rem',
      fontWeight: '600',
    },
    card__info__owner: {
      fontSize: '1.4rem',
      fontWeight: '400',
    },
    card__info__date: {
      display: 'flex',
      columnGap: '0.4rem',
      alignItems: 'center',
    },
    card__info__date__icon: {
      width: '1.6rem',
      height: '1.6rem',
    },
    card__info__date__text: {
      margin: 0,
      padding: 0,
      fontSize: '1.2rem',
      fontWeight: '400',
      color: '#767676',
    },
    card__button: {
      display: 'flex',
      alignItems: 'center',
    },
  };

  handleImageError = (e) => {
    if (this.props.eventIcon && this.loadCounter <= 3) {
      e.target.src = this.props.eventIcon;
    } else {
      // e.target.src = defaultImage;
    }
    this.loadCounter = this.loadCounter + 1;
  }
  render() {
    const { event = {}, onEventClick = () => {} , eventIcon = [] } = this.props;
         let eventImage = event?.eventImageURL;
        const imageFormat = CommonUtil.checkImageURLFormat(eventImage);
    return (
      <div style={this.styles.card}>
        <style>
          {`.event-icon img, .event-icon svg {
                width: 6.8rem !important;
                height: 6.8rem !important;
          }`}
        </style>
        <EventIcon
            event_id={this.props.eventId}
            event_icon={eventIcon}
            hide_border={true}
            event_theme_color={this.props.themeData?.color_500}
             event_image={!imageFormat ? eventImage : null}
            />
        <div style={this.styles.card__info}>
          <div style={this.styles.card__info__name} className='event-search-name'>{event.eventName}</div>
          {event && event.owners.length > 0 && event.owners.map((owner, ownerIndex) => (
            <div
              className='event-search-name'
              key={ownerIndex}
              style={this.styles.card__info__owner}
            >{`${owner.firstName} ${owner.lastNameOrPaternalName} ${owner.motherName}`}</div>
          ))}
          <div style={this.styles.card__info__date}>
            <span className='icon-address-svg' dangerouslySetInnerHTML={{ __html: calendarSvgIcon }} />
            {/* <img
              src={`${CommonUtil.getAssetURL()}/images/icons/event.svg`}
              alt="icon"
              style={this.styles.card__info__date__icon}
            /> */}
            <span style={this.styles.card__info__date__text}>{ event.eventDate ? CommonUtil.formatDate(event.eventDate,"dd/mm/yyyy") :'N/A'}</span>
          </div>
        </div>
        <div
          onClick={() => onEventClick(event.eventId, event.eventCategory, event.eventType)}
          style={this.styles.card__button}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z" fill="#333333" />
          </svg>
        </div>
      </div>
    );
  }
}
